// Что пользователь просил не спрашивать повторно. Экраны 04 и 11.
//
// Настройка хранится на сервере, а не в браузере: обещание «больше не
// спрашивать про проверки» дано человеку, а не устройству, и на телефоне
// оно должно действовать тоже.

import type { UnitId } from '@smyslika/core'

import type { Client } from './client.ts'

export type ConfirmationPrefs = Partial<Record<UnitId, boolean>>

export const createConfirmations = (client: Client) => ({
  read: () => client.request<{ prefs: ConfirmationPrefs }>('/v1/confirmations'),
  /** Запомнить решение для одной единицы. */
  set: (unit: UnitId, skip: boolean) =>
    client.request<{ prefs: ConfirmationPrefs }>('/v1/confirmations', {
      method: 'PUT',
      body: { unit, skip },
    }),
  /** Снова спрашивать про всё — экран 11. */
  reset: () => client.request<{ prefs: ConfirmationPrefs }>('/v1/confirmations', { method: 'DELETE' }),
})

export type Confirmations = ReturnType<typeof createConfirmations>
